<project-navigation
  [headerTitle]="'projectNavigation.ProServe_import_title'"
  [headerText]="'projectNavigation.ProServe_import_message'"
  [model]="model"
  [submitEnabled]="submitEnabled"
  [actionButtonLabel]="'importExportProject.import.button.label'"
  [visibleFeatures]="{
    compositeCheckBox: false,
    pinnedProjects: false,
    recentlyUsedProjects: false,
    history: true,
    projectActionsMenu: true,
    projectGroupContextMenu: true,
    newConfigurationGroupBtn: false,
    newFolderBtn: true,
    dialogSearch: false,
    tabs: true,
    breadcrumbs: true,
  }"
  (submitEnabledChanged)="updateSubmitEnabled()"
  (actionBtnClick)="importProserve()"
  (cancel)="cancel()"
></project-navigation>
